export default __webpack_public_path__ + "static/creators-hero-dark-4db3cbfa99a4adc80f672ca68ff7c508.png";